var $c685891476dbaaca$exports = {};
$c685891476dbaaca$exports = {
  "longPressMessage": "Naci\u015Bnij i przytrzymaj lub naci\u015Bnij klawisze Alt + Strza\u0142ka w d\xF3\u0142, aby otworzy\u0107 menu"
};
export { $c685891476dbaaca$exports as default };